module.exports = "<div>\n  <div id=\"itemDirectiveTranscludeHere\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dragdropway/components/dragdrop/ddDecorItem/edaDragDropWay.dragdrop.ddDecorItem.template.html
// module id = 62
// module chunks = 0